"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCart = void 0;
var React = __importStar(require("react"));
var IconCart = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M3.99744832,21.0898 L4.89405351,6.9998 L7.42511606,6.9948 C7.02174357,8.7598 7.00876376,10.3508 7.00876376,10.4998 C7.00876376,10.7758 7.23141739,10.9998 7.50798714,10.9998 C7.78355845,10.9998 8.00721052,10.7768 8.00721052,10.4998 C8.00721052,10.4648 8.02418412,8.7648 8.46050536,6.9938 L15.5384945,6.9808 C15.977811,8.7568 15.9947846,10.4648 15.9947846,10.4998 C15.9947846,10.7768 16.2184367,10.9998 16.494008,10.9998 C16.7695793,10.9998 16.9932314,10.7758 16.9932314,10.4998 C16.9932314,10.3508 16.9802516,8.7498 16.5728853,6.9788 L19.0769898,6.9738 L20.0374956,20.9998 L3.99744832,21.0898 Z M12.0009976,2.9998 C13.70934,2.9998 14.6848225,4.3948 15.2439527,5.9808 L8.75205181,5.9928 C9.311182,4.4018 10.2886614,2.9998 12.0009976,2.9998 L12.0009976,2.9998 Z M20.0724412,6.9168 C20.0724412,6.3968 19.6401138,5.9738 19.1079417,5.9738 L19.1069432,5.9738 L16.2993109,5.9798 C15.6543143,3.9478 14.4122465,1.9998 12.0009976,1.9998 C9.58275952,1.9998 8.3396933,3.9578 7.69669358,5.9948 L4.89305507,5.9998 C4.36188139,5.9998 3.92955394,6.4228 3.93055238,6.9098 L3,21.0568 C3,21.5768 3.43232745,21.9998 3.96350113,21.9998 L20.0374956,21.9998 C20.5686693,21.9998 21.0009967,21.5768 20.9999983,21.0248 L20.0724412,6.9168 Z" }))); };
exports.IconCart = IconCart;
exports.IconCart.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconCart;
